// extracted by mini-css-extract-plugin
export default {"layout":"App_layout__2jxke","footer":"App_footer__hzmKV"};